module.exports = __webpack_public_path__ + "img/hammer.647d26bd.png";